import clsx from 'clsx';

import './styles.css';
/*
interface KitoSidebarProps{
  open: boolean;
  children: ReactNode;
}
*/

export default function KitoSidebar({ open, children }) {
  return <div className={clsx('kito-sidebar', !open && 'kito-sidebar__hidden')}>{children}</div>;
}
